import { render, staticRenderFns } from "./activityTab.vue?vue&type=template&id=36582842&scoped=true&"
import script from "./activityTab.vue?vue&type=script&lang=js&"
export * from "./activityTab.vue?vue&type=script&lang=js&"
import style0 from "./activityTab.vue?vue&type=style&index=0&id=36582842&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36582842",
  null
  
)

export default component.exports